import { useDispatch, useSelector } from 'react-redux'
import { KAKAO_SERVICE } from 'features/crux/tracker/modal/kakaoService/KakaoServiceCodes'
import Table from 'components/table/Table'
import TableCheckBox from 'components/table/TableCheckBox'
import {
  addId,
  checkAll,
  clearId,
  removeId,
} from 'features/crux/tracker/modal/kakaoService/kakaoServiceTrackSlice'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import FixedTable from 'components/table/FixedTable'

const PlusFriends = () => {
  const dispatch = useDispatch()
  const { content, selected, isLoading } = useSelector(
    state => state.tracker.kakaoServiceTrack
  )
  const items = content[KAKAO_SERVICE.plusfriend.name]
  const selectedItems = selected[KAKAO_SERVICE.plusfriend.name]
  const allChecked =
    selectedItems.length > 0 && items.length === selectedItems.length

  const handleCheckedChange = (checked, id) => {
    if (checked) {
      dispatch(addId(id))
    } else {
      dispatch(removeId(id))
    }
  }
  const handleAllCheckedChange = checked => {
    if (checked) {
      dispatch(checkAll())
    } else {
      dispatch(clearId())
    }
  }

  return (
    <FixedTable
      loading={isLoading}
      caption="카카오톡 채널 표"
      emptyMessage={`선택 가능한 카카오톡 채널이 없습니다.`}>
      <Table.Head>
        <Table.Column
          title={
            <TableCheckBox
              checked={allChecked}
              onCheckedChange={handleAllCheckedChange}
              disabled={items.length === 0}
            />
          }
          thClassName="align_c"
          width={58}
        />
        <Table.Column title="카카오톡 채널" width={242} />
        <Table.Column title="친구수" width={115} />
        <Table.Column title="타 픽셀 &amp; SDK 연동 상태" />
      </Table.Head>
      <Table.Body>
        {items.map(
          ({
            targetKey,
            targetKeyDesc,
            friendCount,
            trackId,
            serviceName,
            profileImage,
          }) => {
            const contains = selectedItems.includes(targetKey)
            const checkBoxId = `chk_${targetKey}`
            return (
              <Table.Row
                key={targetKey}
                rowId={targetKey}
                className={classNames({ on: contains })}>
                <td className="align_c">
                  <div className="inner_tbl">
                    <TableCheckBox
                      id={checkBoxId}
                      checked={contains}
                      onCheckedChange={checked => {
                        handleCheckedChange(checked, targetKey)
                      }}
                    />
                  </div>
                </td>
                <td>
                  <div className="inner_tbl">
                    <span className="link_txt fc_black">
                      <span className="img_profile">
                        <img src={profileImage} alt="" />
                      </span>
                      <span className="inner_g">{targetKeyDesc}</span>
                      <span />
                    </span>
                  </div>
                </td>
                <td className="align_r">
                  <div className="inner_tbl">
                    <NumberFormat
                      value={friendCount}
                      displayType="text"
                      thousandSeparator
                    />
                  </div>
                </td>
                <td>
                  <div className="inner_tbl">
                    {trackId && (
                      <>
                        {serviceName}
                        <p className="fc_gray">{trackId}</p>
                      </>
                    )}
                  </div>
                </td>
              </Table.Row>
            )
          }
        )}
      </Table.Body>
    </FixedTable>
  )
}
export default PlusFriends
